export enum productStatus {
  active = "active",
  disabled = "disabled",
  staging = "staging",
}
